export default "__VITE_ASSET__CXoVzpzV__"